module.exports = __webpack_public_path__ + "img/71.8d0063b9.jpg";